import { withTranslation } from 'react-i18next'
import Clients from './Clients'

export default withTranslation()(Clients)
